var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * Affected endpoints
 * POST /public/deal
 */
// As Deal with validations
import { IsArray, IsBoolean, IsEmail, IsIn, IsOptional, IsString, MaxLength } from 'class-validator';
export const howDoYouKnowUsValues = [
    'RECOMMENDATION',
    'SOCIAL',
    'BONILLA',
    'GOOGLE',
    'EVENT',
    'MANFRED-DAILY',
    'MANFREDITE',
    'CIRCULAR',
    'YOUR-OFFER-SALARY-LANDING',
    'OTHER'
];
export const preferredPackValues = ['TRIAL', 'STANDARD', 'SAVINGS', 'INFO'];
export const sourceValues = ['Manfred Web', 'Manfred Web - Paid', 'Manfred Web - Consulting'];
export class DealCreateRequest {
}
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], DealCreateRequest.prototype, "name", void 0);
__decorate([
    MaxLength(255),
    IsEmail(),
    __metadata("design:type", String)
], DealCreateRequest.prototype, "email", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], DealCreateRequest.prototype, "contactPhone", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], DealCreateRequest.prototype, "company", void 0);
__decorate([
    IsString(),
    MaxLength(8000),
    __metadata("design:type", String)
], DealCreateRequest.prototype, "description", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DealCreateRequest.prototype, "isSubscribeToNewsletter", void 0);
__decorate([
    IsString(),
    IsIn(sourceValues),
    IsOptional(),
    __metadata("design:type", Object)
], DealCreateRequest.prototype, "source", void 0);
__decorate([
    IsString(),
    IsIn(howDoYouKnowUsValues),
    IsOptional(),
    __metadata("design:type", Object)
], DealCreateRequest.prototype, "howDoYouKnowUs", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], DealCreateRequest.prototype, "consultingOptions", void 0);
__decorate([
    IsString(),
    IsIn(preferredPackValues),
    IsOptional(),
    __metadata("design:type", String)
], DealCreateRequest.prototype, "preferredPack", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], DealCreateRequest.prototype, "recaptchaToken", void 0);
//# sourceMappingURL=deal-create.request.js.map